import axios from 'axios';

// this.$session.start();
// var token = this.$session.getItem('token');

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token'); // Assuming you store the token in localStorage
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let isAlertShown = false;

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorCode = error.response.data.code;
    if (errorCode == 401 && !isAlertShown) {
      isAlertShown = true;

      alert('Authentication failed/expired, please relogin');

      sessionStorage.clear();
      localStorage.clear();
      location.href = '#/login';

      return Promise.reject(error);
    }
  }
);

export default instance;
